import apiClient from '@/lib/api-client';
import { ApiError } from '@/model/ApiError';
import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';
import {
    ResetPasswordRequest,
    ResetPasswordRequestFormData,
} from '@/model/ResetPassword';

@Module({ namespaced: true, preserveState: false })
export default class ResetPasswordStorage extends VuexModule {
    error: ApiError | null = null;

    @Mutation
    setError(error: ApiError | null): void {
        this.error = error;
    }

    @Action
    resetPasswordRequest(
        formData: ResetPasswordRequestFormData,
    ): Promise<void> {
        return apiClient
            .post<ResetPasswordRequestFormData, void>(
                '/auth/reset-password-request',
                formData,
            )
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    resetPassword(requestData: ResetPasswordRequest): Promise<void> {
        return apiClient
            .post<ResetPasswordRequest, void>(
                '/auth/reset-password',
                requestData,
            )
            .catch((err) => {
                const error = { ...err };

                if (error?.key === 'not-found.user') {
                    error.key = `reset-password.${error.key}`;
                }

                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    get getError(): ApiError | null {
        return this.error;
    }
}
